module.exports = __WEBPACK_EXTERNAL_MODULE_58__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","setYear"],"commonjs":"date-fns/set_year/index","commonjs2":"date-fns/set_year/index"}
// module id = 58
// module chunks = 0